export default __webpack_public_path__ + "static/latitude-infinity-rewards-visa-card-horizontal-6ebddb46aff51ac79fd8f857d8be7fda.png";